<template>
  <div>
    <app-header></app-header>
    This Maven 2.0 feature is coming soon!
  </div>
</template>

<script>
import Header from '../header/Header'
export default {
  components: {
    'app-header': Header
  }
}
</script>

<style scoped>

</style>
